var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgMaintain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.55 26.0583L32.1054 36.6664C33.9173 34.9234 35.4883 33.412 36.6665 32.2764L26.0184 21.5772L24.7157 15.7884L15.2145 9.99976L12.6072 12.6153L9.99988 15.2287L15.7749 24.7527L21.55 26.0583Z",
    fill: "url(#paint0_linear_1941_26033)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1897 43.333L67.9578 58.0809C70.6806 60.8068 70.6806 65.2276 67.9578 67.9553C65.2351 70.6811 60.824 70.6811 58.1012 67.9553L43.3333 53.2074L53.1897 43.333Z",
    fill: "url(#paint1_linear_1941_26033)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4331 33.1519C73.1558 28.1247 74.112 22.4118 72.8322 17.5941C72.7944 17.2116 72.6999 16.8902 72.3551 16.6501L71.2034 15.7366C71.0038 15.5555 70.7348 15.468 70.4658 15.4925C70.1946 15.5189 69.9487 15.6531 69.7891 15.8668L63.1647 24.2042C62.9798 24.4504 62.6813 24.5907 62.3682 24.5806L59.9639 24.7515C59.758 24.7454 59.5583 24.6742 59.3964 24.548L54.7519 20.7374C54.5628 20.5888 54.4387 20.3772 54.4071 20.1432L54.1192 18.0354C54.0855 17.8035 54.1465 17.5675 54.2894 17.3762L60.4913 9.21983C60.773 8.84548 60.7184 8.32673 60.3694 8.01137L58.8646 6.87205C58.5703 6.6076 58.2362 6.64419 57.7801 6.7296C53.4969 7.54744 46.1833 11.5636 44.3275 17.1137C42.6925 21.9986 43.262 25.4429 43.262 25.4429C43.262 28.1957 42.3268 30.8487 41.1771 31.9615L8.86273 61.995C8.79965 62.05 8.73872 62.1069 8.67779 62.166C6.00868 64.7498 6.01285 68.9429 8.59157 71.4393C11.1703 73.9356 15.5668 74.0007 18.2359 71.4169C18.36 71.2968 18.4798 71.1727 18.5912 71.0446L49.7521 38.4356C53.5854 35.1315 61.1745 38.6512 67.4331 33.1519Z",
    fill: "url(#paint2_linear_1941_26033)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1941_26033",
    x1: 23.3377,
    y1: 9.99976,
    x2: 32.4021,
    y2: 33.1114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1941_26033",
    x1: 56.6711,
    y1: 43.333,
    x2: 65.7355,
    y2: 66.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1941_26033",
    x1: 40.0113,
    y1: 6.6665,
    x2: 62.6722,
    y2: 64.4456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A011"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMaintain);
export default __webpack_public_path__ + "static/media/img_maintain.6d9eb54d304190c96fa563323f75d5de.svg";
export { ForwardRef as ReactComponent };